'use strict';

require('./cn-questionnaire-text-area.scss');

module.exports = {
  template: require('./cn-questionnaire-text-area.html'),
  controller: require('./cn-questionnaire-text-area.controller'),
  controllerAs: 'vm',

  require: {
    ngModel: 'ngModel'
  },

  bindings: {
    head: '@',
    rows: '<',
    locked: '<',
    error: '<',
    panelClass: '@',
    managerAnswer: '@',
    employeeAnswer: '@',
    autosaveFunc: '&'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-questionnaire-text-area/index.js
 ** module id = 96
 ** module chunks = 0
 **/